import React from "react";
import { getBgColorFromHex } from '@utils/general';
import CheckIcon from "@svgs/check-icon.svg";
import XIcon from "@svgs/x-icon.svg";
import HorizontalLine from "@svgs/horizontal-line.svg";
import Image from "../image";

const ComparisonTable = ({
	title,
	itemsForComparison,
	tableGroup,
	hideTableLegend,
	hideDescriptionsOnMobile,
	borderRadius,
	bgColor,
}) => {
	const toCamelCase = (str) => {
		const words = str.split(/\s+/);
		const camelCaseWords = words?.map((word, index) => {
			if (index === 0) {
				return word.toLowerCase();
			}
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		});
		return camelCaseWords.join('');
	};
	
	return (
		<div className="mx-auto w-full">
			<div className="pt-10 mx-auto max-w-7xl">
				<h2 className="mt-8 text-center">{title}</h2>
			</div>
			<div className="max-w-screen-xl mx-auto pt-10 pb-12 pl-0 sm:pl-4 pr-0 sm:px-0 lg:py-16 lg:px-8 lg:pt-12 lg:pb-24">
				<div className={`${getBgColorFromHex(
					bgColor
				)} ${borderRadius ? 'rounded-xl' : ''} py-4 px-2 sm:px-4 overflow-x-auto`}>
					<table className="table-fixed w-full">
						<thead className="max-w-full">
							<tr>
								<th className="sm:pl-4 pl-2 lg:w-[400px] xl:w-[500px] min-w-[150px] w-[150px] align-top">
									{!hideTableLegend && (
										<div className="flex flex-row rounded-xl border border-gray-300 w-fit">
											<div className="py-6 px-2 sm:px-6">
												<div className="flex gap-4">
													<img className="" src={CheckIcon} alt="check" height={24} width={24} />
													<div>Yes</div>
												</div>
												<div className="flex gap-4">
													<img className="min-w-[24px] m-auto" src={HorizontalLine} alt="HorizontalLine" height={24} width={24} />
													<div>Sometimes</div>
												</div>
												<div className="flex gap-4">
													<img className="" src={XIcon} alt="XIcon" height={24} width={24} />
													<div>No</div>
												</div>
											</div>
										</div>
									)}
								</th>
								{itemsForComparison?.map((item) => {
									return (
										<th key={item._key} className="text-center px-4 align-bottom w-[90px] md:w-auto md:align-top">
											<div className="h-auto mx-auto mb-2 rounded-8 w-[120px] sm:w-auto min-w-[120px] md:min-w-[190px] min-h-[125px] md:w-1/4 lg:w-1/4 hidden md:block">
												<Image image={item?.image} />
											</div>
											<div className="text-base font-bold">
												{item.title}
											</div>
										</th>
									);
								})}
							</tr>
						</thead>
						<tbody className="pt-4 max-w-full">
							{tableGroup?.map((itemGroup, index) => (
								<>
									<tr key={index} className="border-b py-4 border-gray-600">
										<td className={`py-4 ${index == 0 ? '' : 'pt-10'} sm:px-4 px-2 text-xl xl:text-2xl font-semibold`}>{itemGroup?.title}</td>
									</tr>
									{itemGroup?.comparisonLine?.map((line, lineIndex) => (
										<tr key={lineIndex}
											className={
												lineIndex === itemGroup.comparisonLine?.length - 1
													? ""
													: "border-b border-gray-300"
											}
										>
											<td className="py-4 sm:px-4 px-2 lg:text-base lg:w-[400px] xl:w-[500px] min-w-[150px] w-[150px]">
												<p className="text-lg">{line?.title}</p>
												<p className={`text-gray-500 text-sm ${hideDescriptionsOnMobile && "hidden"} flex`}>{line?.description}</p>
											</td>
											{itemsForComparison?.map((item, index) => {
												const value = line?.items?.find((itemData) => Object.keys(itemData).includes(toCamelCase(item.title)));
												const itemValue = value ? value[toCamelCase(item.title)] : '';
												const itemAlts = {
													"true": "yes",
													"false": "no",
													"null": "sometimes",
												}

												return (
													<td
														key={index}
														className="text-gray-700 font-owners-text text-center font-normal leading-5"
													>
														{(!itemValue || ['true', 'false', 'null'].includes(itemValue)) 
														? <img className="mx-auto" src={itemValue === 'true' ? CheckIcon : itemValue === 'false' ? XIcon : HorizontalLine} alt={Object.entries(itemAlts).find(([key, value]) => key === itemValue)?.[1] || "sometimes"} /> 
														: itemValue }
													</td>
												);
											})}
										</tr>
									))}
								</>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};

export default ComparisonTable;